import React, { useState } from "react";
import { hoyISO, sumarDias } from "@/lib/zona";
import { CalendarClock, Clock, Check, X } from "lucide-react";
import { toast } from "sonner";
import { useData } from "@/context/DataContext";

const todayStr = hoyISO;
const addDays = (baseIso, days) => {
  const hoy = todayStr();
  return sumarDias(baseIso > hoy ? baseIso : hoy, days); // posponer desde hoy si ya venció
};

// Acciones rápidas para un seguimiento, reutilizable en Inicio y Próximos.
export const SeguimientoActions = ({ recordatorioId, fecha, onChanged, testidPrefix = "seg" }) => {
  const { actualizarRecordatorio, eliminarRecordatorio } = useData();
  const [showDate, setShowDate] = useState(false);
  const [busy, setBusy] = useState(false);

  const run = async (fn, okMsg) => {
    setBusy(true);
    try { await fn(); toast.success(okMsg); onChanged?.(); }
    catch { toast.error("No se pudo actualizar el seguimiento."); }
    finally { setBusy(false); setShowDate(false); }
  };

  const posponer = () => run(
    () => actualizarRecordatorio(recordatorioId, { reminder_date: addDays(fecha || todayStr(), 7) }),
    "Pospuesto 7 días",
  );
  const hecho = () => run(
    () => actualizarRecordatorio(recordatorioId, { status: "Hecho" }),
    "Marcado como realizado",
  );
  const cancelar = () => run(
    () => eliminarRecordatorio(recordatorioId),
    "Seguimiento cancelado",
  );
  const cambiarFecha = (val) => {
    if (!val) return;
    run(() => actualizarRecordatorio(recordatorioId, { reminder_date: val }), "Fecha actualizada");
  };

  const btn = "flex items-center gap-1.5 min-h-[40px] px-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50";

  return (
    <div className="mt-3" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center flex-wrap gap-2">
        <button data-testid={`${testidPrefix}-hecho`} onClick={hecho} disabled={busy}
          className={`${btn} bg-[#3A6B56] text-white hover:bg-[#2E5645]`}>
          <Check size={15} /> Hecho
        </button>
        <button data-testid={`${testidPrefix}-posponer`} onClick={posponer} disabled={busy}
          className={`${btn} bg-white border border-[#E5DFD5] text-[#4A5550] hover:border-[#3A6B56]`}>
          <Clock size={15} /> Posponer 7 días
        </button>
        <button data-testid={`${testidPrefix}-cambiar-fecha`} onClick={() => setShowDate((s) => !s)} disabled={busy}
          className={`${btn} bg-white border border-[#E5DFD5] text-[#4A5550] hover:border-[#3A6B56]`}>
          <CalendarClock size={15} /> Cambiar fecha
        </button>
        <button data-testid={`${testidPrefix}-cancelar`} onClick={cancelar} disabled={busy}
          className={`${btn} bg-white border border-[#E5DFD5] text-[#9AA39D] hover:text-[#B91C1C] hover:border-[#FCA5A5] ml-auto`}>
          <X size={15} /> Cancelar
        </button>
      </div>
      {showDate && (
        <input
          data-testid={`${testidPrefix}-fecha-input`}
          type="date"
          min={todayStr()}
          defaultValue={fecha || ""}
          onChange={(e) => cambiarFecha(e.target.value)}
          className="mt-2 w-full min-h-[48px] px-4 rounded-xl bg-white border border-[#E5DFD5] text-base text-[#1C2421] focus:outline-none focus:border-[#3A6B56]"
        />
      )}
    </div>
  );
};
